import React from "react";
import { Flex, Box, Text, Icon } from "@chakra-ui/react";
import { BsStars } from "react-icons/bs";

export const NewsTabs = ({ activeTab, onTabChange }) => {
  const tabs = [
    { id: "all", label: "All" },
    { id: "host-hub", label: "Host Hub" },
    { id: "trainers-toolkit", label: "Trainer's Toolkit" },
    { id: "feature-lab", label: "Feature Lab" },
  ];

  return (
    <Flex align="center" position="relative" mt='14px'>
      <Flex align="center" gap={0}>
        {tabs.map((tab) => {
          const isActive = activeTab === tab.id;

          return (
            <Box
              key={tab.id}
              position="relative"
              cursor="pointer"
              onClick={() => onTabChange(tab.id)}
            >
              <Box px={3} pb={2}>
                <Text
                  fontSize="xs"
                  fontWeight="500"
                  lineHeight="1.5"
                  color={isActive ? "#4C47CC" : "granite"}
                  fontFamily="Geist, sans-serif"
                  textAlign="center"
                  transition="color 0.2s"
                  _hover={{ color: isActive ? "#4C47CC" : "dark.500" }}
                >
                  {tab.label}
                </Text>
              </Box>

              {isActive && (
                <Box
                  position="absolute"
                  bottom={0}
                  left={0}
                  right={0}
                  h="2px"
                  bg="#4C47CC"
                />
              )}

              {!isActive && (
                <Box
                  position="absolute"
                  bottom={0}
                  left={0}
                  right={0}
                  h="1px"
                  bg="rgba(208, 204, 213, 0.3)"
                />
              )}
            </Box>
          );
        })}
      </Flex>
    </Flex>
  );
};
